const DatosInteligentes = () => {
  return (
    <section
      className="centered-section"
      style={{ marginBottom: 50, position: "relative" }}
      id="data"
    >
      <span
        className="horizontal gap-8"
        style={{
          color: "white",
          marginInline: "auto",
          width: "fit-content",
        }}
      >
        <span className="linea-negra"></span>
        <p className="datos-upper-text">Medilo, mejoralo</p>
        <span className="linea-negra"></span>
      </span>
      <p
        className="section-title"
        style={{
          marginInline: "auto",
          textAlign: "center",
          margin: "2rem 0px",
        }}
      >
        Cosecha el éxito con{" "}
        <span
          style={{
            color: "var(--red-highlight)",
          }}
        >
          datos inteligentes
        </span>
      </p>
      <p className="section-subtitle" style={{ textAlign: "center" }}>
        Respalde sus decisiones con una amplia gama de servicios de BI.
        <br />
        Desde la implementación de plataformas hasta el desarrollo de tableros
        personalizados, <br />
        utilizando las últimas tecnologías como MicroStrategy y Power BI.
      </p>
      <p
        className="centered-section-subtitle"
        style={{
          // fontWeight: 500,
          margin: "1rem 0 4rem 0",
          // fontSize: "1.5rem",
          // lineHeight: "1.5rem",
        }}
      >
        ¿Por qué la inteligencia empresarial es su próxima mejor inversión?
      </p>

      {/* <div style={{ width: "90%", marginInline: "auto" }}> */}
      <img
        alt="pasos"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/pasos.png`}
        style={{ width: "100%" }}
        id="img-pasos"
      />
      {/* </div> */}
    </section>
  );
};

export default DatosInteligentes;
